import React, {Component} from 'react';
import {withTheme} from 'styled-components';
import c3 from 'c3';

import {format, subDays, subMonths} from 'date-fns';

import getUsersISOLocale from 'utils/i18n/getUsersISOLocale';
import {darken, getPalette} from 'utils/ui';

import {C3Styles} from 'components/BigChart/C3Styles';

function defaultTooltipFormat(date) {
	return Intl.DateTimeFormat(getUsersISOLocale(), {
		month: 'short',
		year: 'numeric',
		day: 'numeric',
	}).format(date);
}

/**
 * @deprecated Use SimpleChart instead
 */
class SparkLine extends Component {
	constructor(props) {
		super(props);
		this.state = {
			id: 'sparkline-' + Math.floor(Math.random() * 10_000_000 + 1),
		};
		this.generateChart = this.generateChart.bind(this);
	}

	render() {
		return (
			<C3Styles
				id={this.state.id}
				className={`c3 ${this.props.className}`}
			/>
		);
	}

	generateChart(data) {
		const numOfPoints = data.length;
		let dates = [];
		let xAxisType = 'timeseries';
		let keyFormat = '%Y-%m-%d';
		let tickFormat = '%d';
		let tooltipFormat = defaultTooltipFormat;

		if (numOfPoints === 12) {
			for (let i = numOfPoints - 1; i >= 0; i--) {
				dates[numOfPoints - 1 - i] = format(
					subMonths(new Date(), i),
					'yyyy-MM-dd'
				);
			}
			xAxisType = 'timeseries';
			keyFormat = '%Y-%m-%d';
			tickFormat = function (date) {
				return new Intl.DateTimeFormat(getUsersISOLocale(), {
					month: 'short',
				})
					.format(date)
					.charAt(0);
			};
			tooltipFormat = function (date) {
				return new Intl.DateTimeFormat(getUsersISOLocale(), {
					month: 'short',
					year: 'numeric',
				}).format(date);
			};
		} else {
			for (let i = numOfPoints - 1; i >= 0; i--) {
				dates[numOfPoints - 1 - i] = format(
					subDays(new Date(), i),
					'yyyy-MM-dd'
				);
			}
		}

		dates = ['x'].concat(dates);

		const max = [Math.max(...data)];
		data = [this.props.title].concat(data);

		const {theme} = this.props;
		const startColor = theme.links;
		let endColor = theme.highlight;
		if (startColor === endColor) {
			endColor = darken(startColor, 0.5);
		}
		const palette = getPalette(startColor, endColor, 4);

		if (data.length > 1) {
			c3.generate({
				bindto: '#' + this.state.id,
				size: {
					height: 125,
				},
				padding: {
					left: 5,
					right: 5,
				},
				point: {show: false},
				color: {pattern: palette},
				data: {
					x: 'x',
					xFormat: keyFormat,
					columns: [dates, data],
					classes: {
						sparkdate: 'sparkline',
					},
				},
				axis: {
					x: {
						show: true,
						type: xAxisType,
						tick: {
							format: tickFormat,
							outer: false,
						},
					},
					y: {
						show: false,
						tick: {
							values: max,
						},
					},
				},
				tooltip: {
					format: {
						title: tooltipFormat,
					},
				},
				grid: {y: {show: true}},
			});
		}
	}

	componentDidMount() {
		this.generateChart(this.props.data);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.generateChart(nextProps.data);
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.data !== this.props.data;
	}
}

export default withTheme(SparkLine);
